import { WidgetModule } from "~/services/modules";
import { ListLinksWidget } from "./widgets/links";

export default class ListsModule extends WidgetModule {
	public constructor() {
		super("lists");
	}

	public onSetup(): void | Promise<void> {
		this.registerWidget("lists-links", new ListLinksWidget());
	}

	public onReady(): void | Promise<void> {}
}
